<script setup lang="ts">
// Composer chat assistant — partage entre AssistantDrawer et AssistantPage.
// P8.H.

import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useChatStore } from "@/features/assistant/stores/chat-store";
import Button from "@/shared/ui/Button.vue";

defineExpose({ focus });

const store = useChatStore();
const { thinking } = storeToRefs(store);
const input = ref("");
const inputEl = ref<HTMLTextAreaElement | null>(null);

function focus(): void {
  inputEl.value?.focus();
}

function onSubmit(e: Event): void {
  e.preventDefault();
  const text = input.value;
  input.value = "";
  void store.send(text);
}

function onKeydown(e: KeyboardEvent): void {
  if (e.key === "Enter" && !e.shiftKey) {
    e.preventDefault();
    onSubmit(e);
  }
}
</script>

<template>
  <form class="composer" @submit="onSubmit">
    <textarea
      ref="inputEl"
      v-model="input"
      rows="2"
      placeholder="Demande à l'assistant…"
      :disabled="thinking"
      @keydown="onKeydown"
    />
    <Button variant="primary" :disabled="thinking || input.trim().length === 0" type="submit"
      >Envoyer</Button
    >
  </form>
</template>

<style scoped>
.composer {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid rgba(232, 160, 32, 0.15);
}
.composer textarea {
  background: var(--color-navy-light);
  color: var(--color-cream);
  border: 1px solid rgba(232, 160, 32, 0.2);
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  resize: none;
  font-family: var(--font-sans);
  font-size: 0.9rem;
}
</style>
